import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dueDateWrapper", "dueDateInput", "paymentMethodOption", "initialPaymentAmountWrapper", "initialPaymentAmount"]

  connect() {
    this.toggleDueDate()
  }

  toggleDueDate() {
    const selectedOption = this.paymentMethodOptionTargets.find((element) => element.checked)
    const selectedMethod = selectedOption ? selectedOption.value : "cash"
    const creditSelected = selectedMethod === "credit"

    if (!this.hasDueDateWrapperTarget) {
      return
    }

    this.dueDateWrapperTarget.classList.toggle("hidden", !creditSelected)

    if (this.hasDueDateInputTarget) {
      this.dueDateInputTarget.disabled = !creditSelected
    }

    if (this.hasInitialPaymentAmountWrapperTarget) {
      this.initialPaymentAmountWrapperTarget.classList.toggle("hidden", creditSelected)
      this.initialPaymentAmountTarget.disabled = creditSelected
    }
  }

}